import React, { useState, useEffect } from 'react'
import Backdrop from './Backdrop'

interface RenameModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  currentTitle: string
  onConfirm: (newTitle: string) => void
}

export default function RenameModal({
  open,
  onOpenChange,
  currentTitle,
  onConfirm,
}: RenameModalProps) {
  const [title, setTitle] = useState(currentTitle)

  useEffect(() => {
    setTitle(currentTitle)
  }, [currentTitle, open])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const t = title.trim()
    if (t) {
      onConfirm(t)
      onOpenChange(false)
    }
  }

  if (!open) return null

  return (
    <Backdrop onClose={() => onOpenChange(false)}>
      <div
        style={{
          background: 'var(--white)',
          borderRadius: 20,
          width: 420,
          maxWidth: '94vw',
          boxShadow: 'var(--sh-lg)',
          overflow: 'hidden',
          animation: 'mIn .4s cubic-bezier(.16,1,.3,1) both',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '20px 26px 16px',
            borderBottom: '1px solid var(--bd2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}
        >
          <div>
            <h3
              style={{
                fontFamily: "'Playfair Display',serif",
                fontSize: 17,
                fontWeight: 500,
                color: 'var(--navy)',
              }}
            >
              Rename Chat
            </h3>
            <p style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 2 }}>
              Enter a new name for this conversation
            </p>
          </div>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            style={{
              width: 28,
              height: 28,
              borderRadius: 7,
              border: '1px solid var(--bd)',
              background: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 15,
              color: 'var(--muted)',
            }}
          >
            ✕
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ padding: '20px 26px' }}>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter chat name"
              autoFocus
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: 14,
                color: 'var(--text)',
                background: 'var(--bg2)',
                border: '1px solid var(--bd)',
                borderRadius: 9,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div
            style={{
              padding: '14px 26px 20px',
              borderTop: '1px solid var(--bd2)',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
            }}
          >
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              style={{
                padding: '7px 16px',
                borderRadius: 9,
                border: '1px solid var(--bd)',
                background: 'transparent',
                fontSize: 12.5,
                fontWeight: 500,
                color: 'var(--muted)',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!title.trim()}
              style={{
                padding: '7px 16px',
                borderRadius: 9,
                border: 'none',
                background: 'var(--navy)',
                fontSize: 12.5,
                fontWeight: 500,
                color: 'var(--white)',
                cursor: title.trim() ? 'pointer' : 'not-allowed',
                opacity: title.trim() ? 1 : 0.6,
              }}
            >
              Rename
            </button>
          </div>
        </form>
      </div>
    </Backdrop>
  )
}
